import styled from 'styled-components';
import { rem } from 'polished';

const StyledWrapperGroupInput = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 60%;
  padding: ${rem('10px')};
  border: 2px dashed ${props => (props.isDragging ? 'red' : 'black')};
  border-radius: ${rem('8px')};
  background-color: ${props =>
    props.isDragging ? props.theme.colors.lightGrey : 'transparent'};
  transition: background-color 0.2s ease, border-color 0.2s ease;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const StyledLabel = styled.p`
  font-family: ${props => props.theme.fonts.bookItalic};
  font-size: ${rem('14px')};
`;

const StyledFileInput = styled.input`
  padding: ${rem('11px')} ${rem('18px')} ${rem('11px')} ${rem('8px')};
  width: 90%;
  border: none;
  outline: none;
  background: transparent;
  ::placeholder {
    color: ${props => props.theme.colors.textSecondary || '#888'};
    font-style: italic;
  }
`;

const StyledButtonPencil = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export {
  StyledButtonPencil,
  StyledFileInput,
  StyledWrapperGroupInput,
  StyledLabel
};
